import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_PATH } from 'src/environments/environment';
import { AbstractCrudService } from '../../components/crud/abstract-crud.service';
import { RELATIVE_URL } from './notification-settings/notification-settings-config';

export interface Notification {
  id: string;
  message: string;
  seen: boolean;
  createdAt: Date;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService extends AbstractCrudService {
  constructor(protected override httpClient: HttpClient) {
    super(httpClient, RELATIVE_URL);
  }

  getUserNotifications(): Observable<Notification[]> {
    return this.httpClient.get<Notification[]>(`${API_PATH}notifications/me`);
  }

  markAsSeen(notificationId: string): Observable<void> {
    return this.httpClient.patch<void>(`${API_PATH}notifications/${notificationId}/mark-as-seen`, {});
  }

  markAllAsSeen(): Observable<void> {
    return this.httpClient.patch<void>(`${API_PATH}notifications/mark-all-as-seen`, {});
  }

  override listAll(params?: any): Observable<any> {
    return this.httpClient.get<any>(`${API_PATH}${this.relativeUrl}`, { params });
  }

  // Método para atualizar configurações de notificações
  changeActives(settings: { module: string; recipients: string[]; emailEnabled: boolean }): Observable<any> {
    return this.httpClient.patch<any>(`${API_PATH}${this.relativeUrl}`, settings);
  }

  getNotificationModules(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${API_PATH}notification-settings`);
  }

  updateNotificationSettings(settings: {
    module: string;
    sendToPartner: boolean;
    sendToCustomer: boolean;
    sendToUser: boolean;
    emailEnabled: boolean;
    customTemplate: string
  }): Observable<any> {
    return this.httpClient.patch<any>(`${API_PATH}notification-settings`, settings);
  }

  updateNotificationSettingsBatch(settings: any[]): Observable<any> {
    return this.httpClient.patch<any>(`${API_PATH}notification-settings/batch`, settings);
  }

  uploadTemplate(formData: FormData): Observable<{ templateUrl: string }> {
    return this.httpClient.post<{ templateUrl: string }>(`${API_PATH}upload-template`, formData);
  }
}
